import React, {Component} from 'react';
import SwiperComponent from 'react-id-swiper';
import 'react-id-swiper/src/styles/css/swiper.css';
import PropTypes from 'prop-types';

class Swiper extends Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value,
            swiper: null,
        };
    }

    render() {
        return (
            <SwiperComponent
                {...this.props}
                on={{
                    ...this.props.on,
                    slideChange: this._handleSlideChange,
                }}
                getSwiper={this._ref}
            />
        );
    }

    componentDidUpdate(prevProps) {
        const {swiper} = this.state;

        if (this.props.value !== prevProps.value && swiper) {
            swiper.slideTo(this.props.value);
        }
    }

    _handleSlideChange = () => {
        const {swiper} = this.state,
            value = swiper && swiper.activeIndex;

        this.setState({value}, () => {
            if (typeof this.props.onChange === 'function') {
                this.props.onChange(value);
            }
        });
    };

    _ref = async swiper => {
        await this.setState({swiper});

        if (typeof this.props.elementRef === 'function') {
            this.props.elementRef(swiper);
        }
    };

    static defaultProps = {
        value: 0,
    };

    static propTypes = {
        elementRef: PropTypes.func,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        onChange: PropTypes.func,
    };
}

export default Swiper;
